import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { getDeptCategory, getMainDept, getSubDept, getUserDesign, getUserPosit, getGrade, getDoctorShifts, getShifts } from './../api/EmpMasterApi';

const JobDetails = forwardRef((props, ref) => {
     // Add validation support
     const emp_type = props.emp_type;
     const [validationErrors, setValidationErrors] = useState({});
     const [deptCategories, setDeptCategories] = useState([]);
     const [mainDepartments, setMainDepartments] = useState([]);
     const [subDepartments, setSubDepartments] = useState([]);
     const [designations, setDesignations] = useState([]);
     const [positions, setPositions] = useState([]);
     const [grades, setGrades] = useState([]);
     const [doctorShifts, setDoctorShifts] = useState([]);
     const [shifts, setShifts] = useState([]);

     // Fetch department categories, main departments, and sub departments on component mount
     useEffect(() => {
          const fetchDropdownData = async () => {
               try {
                    // Fetch department categories
                    const deptCategoryResponse = await getDeptCategory();
                    if (deptCategoryResponse.status && deptCategoryResponse.data) {
                         setDeptCategories(deptCategoryResponse.data);
                    }

                    // Fetch main departments
                    const mainDeptResponse = await getMainDept();
                    if (mainDeptResponse.status && mainDeptResponse.data) {
                         setMainDepartments(mainDeptResponse.data);
                    }

                    // Fetch sub departments
                    const subDeptResponse = await getSubDept();
                    if (subDeptResponse.status && subDeptResponse.data) {
                         setSubDepartments(subDeptResponse.data);
                    }

                    // Fetch designations
                    const designationResponse = await getUserDesign();
                    if (designationResponse.status && designationResponse.data) {
                         setDesignations(designationResponse.data);
                    }

                    // Fetch positions
                    const positionResponse = await getUserPosit();
                    if (positionResponse.status && positionResponse.data) {
                         setPositions(positionResponse.data);
                    }

                    // Fetch grades
                    const gradeResponse = await getGrade();
                    if (gradeResponse.status && gradeResponse.data) {
                         setGrades(gradeResponse.data);
                    }

                    // Fetch doctor shifts
                    const doctorShiftResponse = await getDoctorShifts();
                    if (doctorShiftResponse.status && doctorShiftResponse.data) {
                         setDoctorShifts(doctorShiftResponse.data);
                    }

                    // Fetch shifts
                    const shiftResponse = await getShifts();
                    if (shiftResponse.status && shiftResponse.data) {
                         setShifts(shiftResponse.data);
                    }
               } catch (error) {
                    console.error('Error fetching dropdown data:', error);
               }
          };

          fetchDropdownData();
     }, []);

     // Helper function to clear validation error for a specific field
     const clearFieldError = (fieldName) => {
          setValidationErrors(prev => {
               const newErrors = { ...prev };
               delete newErrors[fieldName];
               return newErrors;
          });
     };

     useImperativeHandle(ref, () => ({
          validateForm: () => {
               const errors = {};

               // Define which fields are required for JobDetails
               // if (!formData.department_category?.trim()) {
               //      errors.department_category = 'Department category is required';
               // }
               // if (!formData.main_department?.trim()) {
               //      errors.main_department = 'Main department is required';
               // }
               // if (!formData.designation_name?.trim()) {
               //      errors.designation_name = 'Designation name is required';
               // }
               // if (!formData.position?.trim()) {
               //      errors.position = 'Position is required';
               // }
               if (!formData.reporting_manager_name?.trim()) {
                    errors.reporting_manager_name = 'Reporting manager is required';
               }
               if (!formData.reporting_manager_empcode?.trim()) {
                    errors.reporting_manager_empcode = 'Reporting manager employee code is required';
               }
               // if (!formData.functional_manager_name?.trim()) {
               //      errors.functional_manager_name = 'Functional manager is required';
               // }
               // if (!formData.skip_level_manager_empcode?.trim()) {
               //      errors.skip_level_manager_empcode = 'Skip level manager employee code is required';
               // }
               if (!formData.week_off?.trim()) {
                    errors.week_off = 'Week off Type is required';
               }

               setValidationErrors(errors);
               return Object.keys(errors).length === 0; // Return true if no errors
          },
          clearValidation: () => {
               setValidationErrors({});
          }
     }));

     const [localFormData, localSetFormData] = useState({
          department_category: '',
          main_department: '',
          sub_department: '',
          designation_name: '',
          grade_name: '',
          position: '',
          reporting_manager_name: '',
          reporting_manager_empcode: '',
          functional_manager_name: '',
          skip_level_manager_empcode: '',
          shift_description: '',
          week_off: '',
          isLeaveApplicable: '',

     });
     const formData = props.formData !== undefined ? props.formData : localFormData;
     const setFormData = props.setFormData !== undefined ? props.setFormData : localSetFormData;

     return (
          <div className="custom_form_wrapper">
               <div className="form-grid">
                    <div className="form-floating">
                         <select
                              className={`form-select ${validationErrors.department_category ? 'is-invalid' : ''}`}
                              name="department_category"
                              id="department_category"
                              value={formData.department_category || ""}
                              onChange={e => {
                                   setFormData({ ...formData, department_category: e.target.value });
                                   if (validationErrors.department_category) clearFieldError('department_category');
                              }}
                         >
                              <option value="" disabled hidden> Department Category</option>
                              {deptCategories.map((category) => (
                                   <option key={category.id} value={category.dept_category}>
                                        {category.dept_category}
                                   </option>
                              ))}
                         </select>
                         <label htmlFor="department_category" style={{ opacity: formData.department_category ? 1 : 0 }}>Department Category</label>
                         {validationErrors.department_category && (
                              <div className="invalid-feedback">{validationErrors.department_category}</div>
                         )}
                    </div>
                    <div className="form-floating">
                         <select
                              className={`form-select ${validationErrors.main_department ? 'is-invalid' : ''}`}
                              name="main_department"
                              id="main_department"
                              value={formData.main_department || ""}
                              onChange={e => {
                                   setFormData({ ...formData, main_department: e.target.value });
                                   if (validationErrors.main_department) clearFieldError('main_department');
                              }}
                         >
                              <option value="" disabled hidden>Select Main Department</option>
                              {mainDepartments.map((department) => (
                                   <option key={department.id} value={department.main_dept}>
                                        {department.main_dept}
                                   </option>
                              ))}
                         </select>
                         <label htmlFor="main_department" style={{ opacity: formData.main_department ? 1 : 0 }}>Main Department</label>
                         {validationErrors.main_department && (
                              <div className="invalid-feedback">{validationErrors.main_department}</div>
                         )}
                    </div>
                    <div className="form-floating">
                         <select
                              className="form-select"
                              name="sub_department"
                              id="sub_department"
                              value={formData.sub_department || ""}
                              onChange={e => setFormData({ ...formData, sub_department: e.target.value })}
                         >
                              <option value="" disabled hidden>Select Sub Department</option>
                              {subDepartments.map((department) => (
                                   <option key={department.id} value={department.sub_dept}>
                                        {department.sub_dept}
                                   </option>
                              ))}
                         </select>
                         <label htmlFor="sub_department" style={{ opacity: formData.sub_department ? 1 : 0 }}>Sub Department</label>
                    </div>
                    <div className="form-floating">
                         <select
                              className={`form-select ${validationErrors.designation_name ? 'is-invalid' : ''}`}
                              name="designation_name"
                              id="designation_name"
                              value={formData.designation_name || ""}
                              onChange={e => {
                                   setFormData({ ...formData, designation_name: e.target.value });
                                   if (validationErrors.designation_name) clearFieldError('designation_name');
                              }}
                         >
                              <option value="" disabled hidden>Select Designation</option>
                              {designations.map((designation) => (
                                   <option key={designation.id} value={designation.designation_type}>
                                        {designation.designation_type}
                                   </option>
                              ))}
                         </select>
                         <label htmlFor="designation_name" style={{ opacity: formData.designation_name ? 1 : 0 }}>Designation Name</label>
                         {validationErrors.designation_name && (
                              <div className="invalid-feedback">{validationErrors.designation_name}</div>
                         )}
                    </div>
                    <div className="form-floating">
                         <select
                              className="form-select"
                              name="grade_name"
                              id="grade_name"
                              value={formData.grade_name || ""}
                              onChange={e => setFormData({ ...formData, grade_name: e.target.value })}
                         >
                              <option value="" disabled hidden>Select Grade</option>
                              {grades.map((grade) => (
                                   <option key={grade.id} value={grade.grade}>
                                        {grade.grade}
                                   </option>
                              ))}
                         </select>
                         <label htmlFor="grade_name" style={{ opacity: formData.grade_name ? 1 : 0 }}>Grade Name</label>
                    </div>
                    <div className="form-floating">
                         <select
                              className={`form-select ${validationErrors.position ? 'is-invalid' : ''}`}
                              name="position"
                              id="position"
                              value={formData.position || ""}
                              onChange={e => {
                                   setFormData({ ...formData, position: e.target.value });
                                   if (validationErrors.position) clearFieldError('position');
                              }}
                         >
                              <option value="" disabled hidden>Select Position</option>
                              {positions.map((position) => (
                                   <option key={position.id} value={position.position_type}>
                                        {position.position_type}
                                   </option>
                              ))}
                         </select>
                         <label htmlFor="position" style={{ opacity: formData.position ? 1 : 0 }}>Position</label>
                         {validationErrors.position && (
                              <div className="invalid-feedback">{validationErrors.position}</div>
                         )}
                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className={`form-control form-control-sm ${validationErrors.reporting_manager_name ? 'is-invalid' : ''}`}
                              name="reporting_manager_name"
                              id="reporting_manager_name"
                              placeholder=" "
                              value={formData.reporting_manager_name}
                              onChange={e => setFormData({ ...formData, reporting_manager_name: e.target.value })}
                              autoComplete="off"
                         />
                         <label htmlFor="reporting_manager_name">Reporting Manager Name</label>
                         {validationErrors.reporting_manager_name && (
                              <div className="invalid-feedback">{validationErrors.reporting_manager_name}</div>
                         )}
                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="reporting_manager_empcode"
                              id="reporting_manager_empcode"
                              placeholder=" "
                              value={formData.reporting_manager_empcode}
                              onChange={e => setFormData({ ...formData, reporting_manager_empcode: e.target.value })}
                              autoComplete="off"
                         />
                         <label htmlFor="reporting_manager_empcode">Reporting Manager Empcode</label>
                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="functional_manager_name"
                              id="functional_manager_name"
                              placeholder=" "
                              value={formData.functional_manager_name}
                              onChange={e => setFormData({ ...formData, functional_manager_name: e.target.value })}
                              autoComplete="off"
                         />
                         <label htmlFor="functional_manager_name">Functional Manager Name</label>
                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="skip_level_manager_empcode"
                              id="skip_level_manager_empcode"
                              placeholder=" "
                              value={formData.skip_level_manager_empcode}
                              onChange={e => setFormData({ ...formData, skip_level_manager_empcode: e.target.value })}
                              autoComplete="off"
                         />
                         <label htmlFor="skip_level_manager_empcode">Skip Level Manager Empcode</label>
                    </div>


                    <div className="form-floating">
                         {emp_type === "DOCTOR" ? (
                              <select
                                   className="form-select"
                                   name="shift_description"
                                   id="shift_description"
                                   value={formData.shift_description || ""}
                                   onChange={e => setFormData({ ...formData, shift_description: e.target.value })}
                              >
                                   <option value="" disabled hidden>Select Doctor Shift</option>
                                   {doctorShifts.map((shift) => (
                                        <option key={shift.id} value={shift.shift_name}>
                                             {shift.shift_name} ({shift.in_time} - {shift.out_time})
                                        </option>
                                   ))}
                              </select>
                         ) : (
                              <select
                                   className="form-select"
                                   name="shift_description"
                                   id="shift_description"
                                   value={formData.shift_description || ""}
                                   onChange={e => setFormData({ ...formData, shift_description: e.target.value })}
                              >
                                   <option value="" disabled hidden>Select Shift</option>
                                   {shifts.map((shift) => (
                                        <option key={shift.id} value={shift.ShiftName}>
                                             {shift.ShiftName}
                                        </option>
                                   ))}
                              </select>
                         )}
                         <label htmlFor="shift_description">{emp_type} Default Shift </label>
                    </div>


                    <div className="form-floating">
                         <select
                              className="form-select"
                              name="week_off"
                              id="week_off"
                              value={formData.week_off || ""}
                              onChange={e => setFormData({ ...formData, week_off: e.target.value })}
                              required
                         >
                              <option value="" disabled hidden>Week End Type</option>
                              <option value="Fixed_weekend">Fixed_weekend</option>
                              <option value="Custom_weekend">Custom_weekend</option>

                         </select>
                         <label htmlFor="week_off" style={{ opacity: formData.week_off ? 1 : 0 }}>Week Off</label>

                    </div>
                    <div className="form-floating">
                         <select
                              className="form-select"
                              name="isLeaveApplicable"
                              id="isLeaveApplicable"
                              value={formData.isLeaveApplicable || " "}
                              onChange={e => setFormData({ ...formData, isLeaveApplicable: e.target.value })}
                         >
                              <option value=" " disabled hidden>Leave Applicable</option>
                              <option value="Y">Yes</option>
                              <option value="N">No</option>
                         </select>
                         <label htmlFor="isLeaveApplicable" style={{ opacity: formData.isLeaveApplicable ? 1 : 0 }}>Leave Applicable</label>
                    </div>
               </div>
          </div>
     );
});

export default JobDetails;